import { useState } from 'react';

import useStateHandler from '@/hooks/useStateHandler';
import GalleryService from '@/services/gallery.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/CompleteArtist.css';

function CompleteArtistForm({ close, artistToComplete, onComplete }) {
  const { state, cacheHandler } = useStateHandler();
  const [formState, setFormState] = useState(state.user_session._id === artistToComplete.gallery._id ? artistToComplete.artist_email?.toLowerCase() : "");
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState(null);

  async function submitCompleteArtist(e) {
    e.preventDefault();
    setLoading(true);
    setFormError(null);

    const { response, data } = await GalleryService.completeArtistProfile(formState, artistToComplete);

    if(response.ok) {
      onComplete(data);
      cacheHandler.triggerAction("NEW_ARTIST");
      close();
    } else if(response.status === 400) {
      setLoading(false);
      setFormError({ element: data.error_data.element, error_code: data.error_type });
    }
  }

  return (
    <>
      <form onSubmit={submitCompleteArtist} className="complete-artist-form">
        <PublicFormInput 
          readOnly={loading} 
          error={formError} 
          onChange={e=>setFormState(e.target.value)}
          margin
        />

        <Text className="complete-artist-form__text" paragraph justify>
          The artist you selected was originally created under the 'Gallery Owned' category. 
          To assign this artist to a 'Work of Artist' artwork, you must provide the artist's email. 
          This will allow the artist to claim their profile on Suarte. 
        </Text>

        <ContinueButton 
          className="complete-artist-form__button"
          loading={loading} 
          turnOff={!formState}
        >
          Complete profile
        </ContinueButton>
      </form>
    </>
  );
}

export default function CompleteArtist({ open, close, onClose, artistToComplete, onComplete }) {
  return (
    <>
      <GenericPopup className="complete-artist-popup" open={open} opacity>
        <div className="complete-artist-popup__header">
          <Text className="complete-artist-popup__text">
            Complete artist profile
          </Text>

          <XIcon className="complete-artist-popup__close" onClick={()=>{close(); onClose();}}/>
        </div>

        <CompleteArtistForm
          close={close}
          artistToComplete={artistToComplete}
          onComplete={onComplete}
        />
      </GenericPopup>
    </>
  );
}
